<template>
    <div>
        <div class="add-top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/service/service' }">服务商管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="add-content">
            <div class="content">
                <div class="page-title">{{title}}</div>
                <div class="created-box">
                    <div class="left">
                        <div class="item d_flex " @click="changeStep(0)" :class="currentStep>0?'active':'writting'">
                            <div class="step">1</div>
                            <div>基本信息</div>
                        </div>
                        <div class="item d_flex" @click="changeStep(1)"   :class="currentStep>1?'active':(currentStep==1?'writting':'')">
                            <div class="step">2</div>
                            <div>联系信息</div>
                        </div>
                        <div class="item d_flex" @click="changeStep(2)"  :class="currentStep>3?'active':(currentStep==2?'writting':'')">
                            <div class="step">3</div>
                            <div>图片信息</div>
                        </div>
                    </div>
                    <div class="right">
                            <div v-show="currentStep==0" >
                                <el-form ref="form" :model="form" label-width="120px" align="left" :rules="rules" >
                                    <el-form-item label="服务商名称" style="width: 350px;" prop="name">
                                        <el-input v-model="form.name" placeholder="请输入服务商名称"></el-input>
                                    </el-form-item>
                                    <el-form-item label="主营业务" v-if="typeList.length>0" prop="cate_id">
                                        <el-cascader
                                                v-model="form.cate_id"
                                                :options="typeList"
                                                :props="{label:'cate_name',value:'cate_id',children:'child',multiple:true}"
                                                :clearable="true"
                                                @change="handleChange"></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="所属城市"  prop="city_id">
                                        <el-cascader :options="cityArr" v-model="form.city_id"  :props="{ value: 'city_id', label: 'name',children:'child'}" @change="selectType" filterable clearable></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="详细地址" style="width: 500px;" prop="address">
                                        <el-input type="input" v-model="form.address"  @input="getAddress"  placeholder="请输入详细地址"></el-input>
                                    </el-form-item>
                                    <el-form-item label="经纬度" style="width: 830px;"  prop="lng">
                                        <div class="d_flex">
                                            <el-input v-model="form.lng" placeholder="经度" :disabled="true" style="width: 150px; margin-right: 10px;" ></el-input>
                                            <el-input v-model="form.lat" placeholder="纬度" :disabled="true" style="width: 150px; margin-right: 10px;"></el-input>
                                            <span class="col_red">点击地图位置点获取经纬度</span>
                                        </div>
                                    </el-form-item>

                                </el-form>
                                <div class="map-box">
                                    <el-input v-model="addressKeyword" placeholder="输入详细地址查找详细位置"></el-input>
                                    <baidu-map class="bmView" id="baidu-map" :scroll-wheel-zoom="true" :center="location" :zoom="zoom" @click="getLocationPoint" ak="AkfcPW05jWhN7BbQkX7kpH6dfMdzLuME">
                                        <bm-view style="width: 100%; height:400px; flex: 1"></bm-view>
                                        <bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none"></bm-local-search>
                                    </baidu-map>
                                </div>
                            </div>
                            <div v-show="currentStep==1">
                                <el-form ref="form1" :model="form1" label-width="120px" align="left" :rules="rules1">
                                    <el-form-item label="联系人姓名" style="width: 350px;" prop="contact_name">
                                        <el-input v-model="form1.contact_name" placeholder="请输入联系人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人手机号" style="width: 350px;" prop="contact_phone">
                                        <el-input v-model="form1.contact_phone" maxlength="11" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人微信" style="width: 350px;" prop="contact_wx">
                                        <el-input v-model="form1.contact_wx" placeholder="请输入微信"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人职务" style="width: 350px;" >
                                        <el-input v-model="form1.contact_position" placeholder="请输入职务"></el-input>
                                    </el-form-item>
                                    <el-form-item label="服务商介绍" style="width: 500px;">
                                        <el-input type="textarea" v-model="form1.content"  placeholder="请输入服务商介绍" autosize></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div v-show="currentStep==2">
                                <el-form ref="rulesForm" :model="rulesForm" label-width="120px" align="left" :rules="rules2" >

                                    <div class="d_flex">
                                        <el-form-item  label="服务商封面图" style="width: 100%;" prop="fileList2">
                                            <div class="d_flex">
                                                <div class="upload-img-box d_flex" v-if="rulesForm.fileList2.length>0">
                                                    <div class="img" v-for="(item,index) in rulesForm.fileList2">
                                                        <img :src="item|handleImg" @click="previewIMg(item)" alt="">
                                                        <i class="el-icon-error" @click="deleteImg(1,index)"></i>
                                                    </div>
                                                </div>
                                                <el-upload class="avatar-uploader"
                                                           ref="otherLicense"
                                                           :auto-upload="false"
                                                           action
                                                           :multiple="true"
                                                           :on-preview="handlePicPreview2"
                                                           :on-remove="handleRemove2"
                                                           :file-list="rulesForm.fileList2"
                                                           :on-change="otherSectionFile2"
                                                           list-type="picture-card"
                                                           v-if="rulesForm.fileList2.length<1"
                                                >
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="d_flex">
                                        <el-form-item  label="价格介绍图" style="width: 100%;" prop="fileList">
                                            <div class="d_flex">
                                                <div class="upload-img-box d_flex" v-if="rulesForm.fileList.length>0">
                                                    <div class="img" v-for="(item,index) in rulesForm.fileList">
                                                        <img :src="item|handleImg" @click="previewIMg(item)" alt="">
                                                        <i class="el-icon-error" @click="deleteImg(1,index)"></i>
                                                    </div>
                                                </div>
                                                <el-upload class="avatar-uploader"
                                                           ref="otherLicense"
                                                           :auto-upload="false"
                                                           action
                                                           :multiple="true"
                                                           :on-preview="handlePicPreview"
                                                           :on-remove="handleRemove"
                                                           :file-list="rulesForm.fileList"
                                                           :on-change="otherSectionFile"
                                                           list-type="picture-card"
                                                           v-if="rulesForm.fileList.length<1"
                                                >
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </div>

                                        </el-form-item>
                                    </div>
                                    <el-form-item  label="产品介绍图" style="width: 100%;" prop="fileList1">
                                        <el-upload class="avatar-uploader"
                                                   ref="otherLicense"
                                                   action
                                                   :auto-upload="false"
                                                   :on-preview="handlePicPreview1"
                                                   :on-remove="handleRemove1"
                                                   :file-list="rulesForm.fileList1"
                                                   :on-change="otherSectionFile1"
                                                   list-type="picture-card"
                                                   multiple>
                                            <i class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-form>
                            </div>

                    </div>
                </div>
            </div>
            <div class="bottom-box d_flex">
                <el-button @click="backPage">返回</el-button>
                <el-button v-if="currentStep>0" @click="preStep">上一步</el-button>
                <el-button type="primary" @click="nextStep" v-if="currentStep<2">下一步</el-button>
                <el-button type="primary" v-if="currentStep==2" @click="submitForm">提交</el-button>
                <el-button @click="openPreview">在线预览</el-button>
            </div>
        </div>
        <el-dialog
                title="场地详情"
                :visible.sync="infoPop"
                width="375px"
        >
            <div class="info-box" style="text-align: left">
                <p class="item"><span class="info-tit">服务商名称：</span><span class="val">{{form.name}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">服务商类别：</span><span class="val">{{form.big_cate_name}}</span></p>
                    <p><span class="info-tit">服务商小类：</span><span class="val">{{form.cate_name}}</span></p>
                </div>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">所属城市：</span><span class="val">{{form.big_city_name}}</span></p>
                    <p><span class="info-tit">所属区域：</span><span class="val">{{form.city}}</span></p>
                </div>
                <p class="item"><span class="info-tit">详细地址：</span><span class="val">{{form.address}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">管理员：</span><span class="val">{{form1.contact_name}}</span></p>
                    <p><span class="info-tit">管理员职务：</span><span class="val">{{form1.contact_position}}</span></p>
                </div>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">管理员微信：</span><span class="val">{{form1.contact_wx}}</span></p>
                    <p><span class="info-tit">管理员电话：</span><span class="val">{{form1.contact_phone}}</span></p>
                </div>
                <div class="site-img-box">
                    <p>价格介绍图</p>
                    <div class="swiper" v-if="rulesForm.fileList.length>0">
                        <img :src="rulesForm.fileList[0]|handleImg">
                    </div>
                    <p>产品介绍图</p>
                    <div class="swiper"  v-if="rulesForm.fileList1.length>0">
                        <mu-carousel>
                            <mu-carousel-item v-for="(item,i) in rulesForm.fileList1" :key="i">
                                <img :src="item.path|handleImg">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="infoPop = false">取 消</el-button>
                <el-button type="primary" @click="infoPop = false">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import {serviceTypeList,saveService} from '../../api/service'
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import BmView from 'vue-baidu-map/components/map/MapView.vue'
    import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
    import {searchCity} from '../../api/city'
    import { mapState } from 'vuex';
    export default {
        name: "add-site",
        components: {
            BaiduMap,
            BmView,
            BmLocalSearch
        },
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                infoPop:false,
                imgBox:'',
                currentStep:0,
                selfKey: 'AkfcPW05jWhN7BbQkX7kpH6dfMdzLuME',
                form: {
                    name: '',
                    city_id:'',
                    area_id:'',
                    cate_id:[],
                    cate_ids:[],
                    address:'',
                    lng:'',
                    lat:'',
                },
                location: {
                    lng: 116.404,
                    lat: 39.915
                },
                zoom: 12.8,
                addressObj:{
                    city:'',
                    area:'',
                    address:''
                },
                addressKeyword:'',
                rules:{
                    name: [
                        { required: true, message: '请输入服务商名称', trigger: 'blur' }
                    ],
                    city_id:[
                        { required: true, message: '请选择服务商所属城市', trigger: 'blur' }
                    ],
                    address:[
                        { required: true, message: '请输入服务商详细地址', trigger: 'blur' }
                    ],
                    cate_id:[
                        { required: true, message: '请选择服务类型', trigger: 'blur' }
                    ],

                },
                form1:{
                    contact_name:'',
                    contact_phone:'',
                    contact_wx:'',
                    contact_position:'',
                    content:'',
                },
                rules1:{
                    contact_name: [
                        { required: true, message: '请输入联系人名称', trigger: 'blur' }
                    ],
                    contact_phone:[
                        { required: true, message: '请输入联系人手机号', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    contact_wx:[
                        { required: true, message: '请输入联系人微信', trigger: 'blur' }
                    ],
                    contact_position:[
                        { required: true, message: '请输入联系人职位', trigger: 'blur' }
                    ],
                    content:[
                        { required: true, message: '请输入场地介绍', trigger: 'blur' }
                    ],
                },
                rulesForm:{
                    fileList:[],
                    fileList1:[],
                    fileList2:[],
                },
                rules2:{
                    fileList:[
                        { required: true, message: '请选择价格介绍图', trigger: 'blur' }
                    ],
                    fileList1:[
                        { required: true, message: '请选择产品介绍图', trigger: 'blur' }
                    ],
                    fileList2:[
                        { required: true, message: '请服务商封面图', trigger: 'blur' }
                    ],
                },
                typeList:[],
                cityList:[],
                areList:[],
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                edit:0,
                title:'新增服务商',
                serviceData:''
            }
        },
        computed:{
            ...mapState(['baseUrl','cityArr'])
        },
        mounted(){
            this.edit=this.$route.query.type||0;
            if(this.edit==1){
                this.title='修改服务商';
                let service_data=JSON.parse(localStorage.getItem('update_service'));
                this.serviceData=service_data;
                console.log(service_data)
                let arr=service_data.cate_ids.split(',');
                arr=arr.map(val=>{
                    let a=[];
                    a[0]=service_data.big_cate_id;
                    a[1]=parseInt(val);
                    return a;
                });
                this.form={
                        name: service_data.name,
                        city_id:[service_data.big_city_id,service_data.city_id],
                        cate_id:arr,
                        cate_ids:service_data.cate_ids.split(','),
                        content:service_data.content,
                        address:service_data.address,
                        big_city_name:service_data.big_city_name,
                        big_cate_name:service_data.big_cate_name,
                        cate_name:service_data.cate_name,
                        city:service_data.city,
                        lng:service_data.lng,
                        lat:service_data.lat,
                };
                this.form1={
                    contact_name:service_data.contact_name,
                    contact_phone:service_data.contact_phone,
                    contact_wx:service_data.contact_wx,
                    contact_position:service_data.contact_position,
                    content:service_data.content
                };
                this.rulesForm={
                    fileList:[service_data.price_des_img],
                    fileList2:[service_data.cover],
                };
                if(service_data.photo.length>0){
                    this.rulesForm.fileList1=service_data.photo.map((val,index)=>{
                        let obj={};
                        obj.uid=index;
                        obj.url=this.baseUrl+val;
                        obj.path=val;
                        return obj;
                    });
                }else{
                    this.rulesForm.fileList1=[];
                }
                console.log(this.rulesForm.fileList1);
                // localStorage.removeItem('update_service');
                setTimeout(()=>{
                    this.addressKeyword=this.form.address;
                },500)
            }

            this.serviceTypeList();
        },
        methods:{
            backPage(){
                this.$router.push({path: '/service/service'});
            },
            //选择类型
            selectType(e){
                console.log(e);
            },
            getAddress(e){
                this.addressObj.address=this.form.address;
                this.setSearchAddress();
            },
            setSearchAddress(){
                this.addressKeyword=this.addressObj.city+this.addressObj.area+this.addressObj.address;
            },
            getLocationPoint(e) {
                console.log(e);
                this.form.lng = e.point.lng;
                this.form.lat = e.point.lat;
                /* 创建地址解析器的实例 */
                let geoCoder = new BMap.Geocoder();
                /* 获取位置对应的坐标 */
                geoCoder.getPoint(this.addressKeyword, point => {
                    this.selectedLng = point.lng;
                    this.selectedLat = point.lat;
                });
                /* 利用坐标获取地址的详细信息 */
                geoCoder.getLocation(e.point, res=>{
                    console.log(res);
                    this.form.address=res.address;
                })
            },
            //获取服务商类型
            serviceTypeList(){
                serviceTypeList().then(res=>{
                    if(res.code==1){
                        this.typeList=res.data;
                    }
                })
            },
            previewIMg(img){
                this.imgPop=true;
                if(img.indexOf('http')!=-1){
                    this.preImg=img;
                }else{
                    this.preImg=this.baseUrl+img;
                }
            },
            deleteImg(i,j){
                if(i==1){
                    this.rulesForm.fileList.splice(j,1);
                }else if(i==2){
                    this.rulesForm.fileList2.splice(j,1);
                }
            },
            //图片上传处理
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.rulesForm.fileList.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList.splice(index,1)
                    }
                })
            },
            handlePicPreview1(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handlePicPreview2(file){
                console.log(file);
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove1(file, fileList) {
                this.rulesForm.fileList1.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList1.splice(index,1)
                    }
                })

            },
            handleRemove2(file, fileList) {
                this.rulesForm.fileList2.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList2.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                console.log(file)
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        // let obj={}
                        // obj.url='http://cdb.luxinpian.com/'+res.data.data.path;
                        // obj.uuid=file.uid;
                        this.rulesForm.fileList.push(res.data.data.path);
                    }
                })
            },
            otherSectionFile1(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        let obj={
                            url:res.data.data.path,
                            path:res.data.data.path,
                        };
                        this.rulesForm.fileList1.push(obj);
                    }
                    console.log(this.rulesForm.fileList1);
                })
            },
            otherSectionFile2(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'space');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.rulesForm.fileList2.push(res.data.data.path);
                    }
                })
            },
            changeStep(i){
                if(this.currentStep==0){
                    this.$refs['form'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            this.currentStep=i;
                        }
                    });
                    return;
                }
                if(this.currentStep==1){
                    this.$refs['form1'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            this.currentStep=i;
                        }
                    });
                }
            },
            preStep(){
                if(this.currentStep>0){
                    this.currentStep--
                }
            },
            nextStep(){
                if(this.currentStep==0){
                    this.$refs['form'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            if(this.currentStep<2){
                                this.currentStep++
                            }
                        }
                    });
                    return;
                }
                if(this.currentStep==1){
                    this.$refs['form1'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            if(this.currentStep<2){
                                this.currentStep++
                            }
                        }
                    });
                }
            },
            submitForm(){
                console.log(this.rulesForm.fileList1);
                let arr=this.rulesForm.fileList1.map(val=>{
                    return val.path;
                });

                let data={
                    name:this.form.name,
                    cate_ids:this.form.cate_ids.join(','),
                    city_id:this.form.city_id[1],
                    content:this.form1.content,
                    lng_lat:this.form.lng+','+this.form.lat,
                    address:this.form.address,
                    contact_name:this.form1.contact_name,
                    contact_phone:this.form1.contact_phone,
                    contact_wx:this.form1.contact_wx,
                    contact_position:this.form1.contact_position,
                    price_des_img:this.rulesForm.fileList[0],
                    photo:arr.join(','),
                    cover:this.rulesForm.fileList2[0],
                };
                let str='创建成功';
                if(this.edit){
                    data.sid=this.serviceData.sid;
                    str='修改成功'
                }
                saveService(data).then(res=>{
                    if(res.code==1){
                        this.$message.success(str);
                        this.backPage();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            changeSpace(){
                this.form.subType='';
                this.getSubList();
            },
            openPreview(){
                this.infoPop=true;
            },
            handleChange(value) {
                console.log(value);
                this.form.cate_ids=value.map(val=>{
                    return val[1];
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add-top{
        padding: 20px;
    }
    .add-content{
        padding: 20px 20px 120px 20px;
        .content{
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
            position: relative;
            min-height: 450px;
            .page-title{
                text-align: left;
                font-size: 24px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #30323f;
                padding: 10px 0 28px 10px;
                background: #fff;
            }
            .left{
                position: fixed;
                min-height: 400px;
                width: 130px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #eaeaea;
                background-color: #fff;
                z-index: 9;
                .item{
                    width: 120px;
                    height: 40px;
                    margin-bottom: 30px;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    &:hover{
                        background-color: #F7F9FC;
                    }

                    &:nth-child(-n+2){
                        &::after{
                            position: absolute;
                            bottom: -25px;
                            content:'';
                            left: 12px;
                            width: 1px;
                            height: 20px;
                            border-left: 1px dotted #bdbdbd;
                            display: inline-block;
                        }
                    }
                    .step{
                        width: 24px;
                        height: 24px;
                        margin-right: 10px;
                        border-radius: 50%;
                        background-color: #f7f9fc;
                        text-align: center;
                        line-height: 24px;
                        font-size: 15px;
                        color: #c0c4cc;
                    }
                    &.active{
                        .step{
                            background: #2196f3;
                            color: #ffffff;
                        }
                    }
                    &.writting{
                        .step{
                            color: #4890f7;
                            background: rgba(72,144,247,.1);
                        }
                    }
                }
            }
            .right{
                padding-left:  200px;
                min-height: 450px;
                .map-box{
                    width: 800px;
                    height: 400px;
                    background-color: #aaaaaa;
                }
            }
        }
    }
    .bottom-box{
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        padding: 30px 0 30px 250px;
        width: 100%;
        box-shadow: 0 -2px 4px 0 #e1e5eb;
    }

    .info-box{
        .item{
            padding: 10px 0;
            .info-tit{
                font-size: 15px;
                color: #999999;
            }
            .val{
                color: #ff6b11;
            }
        }
        .site-img-box{
            p{
                font-size: 18px;
                color: #333333;
                font-weight: bold;
                margin-top: 20px;
                margin-bottom: 20px;
            }
            .mu-carousel{
                width: 100%;
                height: 300px;
            }
        }
    }
    .upload-img-box{
        width: 100%;
        .img{
            width: 146px;
            height: 146px;
            border-radius: 4px;
            margin-right: 10px;
            position: relative;
            i{
                position: absolute;
                top: -5px;
                font-size: 24px;
                color: #f00;
            }
            .el-icon-error{
                right: -5px;
            }
            img{
                width: 146px;
                height: 146px;
                border-radius: 4px;
            }
        }
    }


</style>
